module.exports = __webpack_public_path__ + "img/four_.b242a812.png";